import React, { memo } from 'react'
import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { modalActions, ModalTypes } from '../../../entities/Modal'
import Tooltip from '@mui/material/Tooltip'
import Button from '@mui/material/Button'
import { SvgIcon } from '../../../shared/ui/SvgIcon/SvgIcon'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons/faPenToSquare'
import { clientLabelActions } from '../../../entities/ClientLabel'
import { faTrashCan } from '@fortawesome/free-regular-svg-icons/faTrashCan'
import { ClientLabelWithLabelView } from '../model/types/ClientLabelsSchema'

interface ClientLabelsActionsProps {
	clientLabel: ClientLabelWithLabelView
}

export const ClientLabelsActions = memo(
	function ClientLabelsActions(props: ClientLabelsActionsProps) {
		const { clientLabel } = props
		const dispatch = useAppDispatch()

		const handleEdit = () => {
			dispatch(modalActions.showModal({
				modalType: ModalTypes.EDIT_CLIENT_LABEL_MODAL
			}))
			dispatch(clientLabelActions.setClientLabelEditable({
				labelId: clientLabel.labelId,
				labelName: clientLabel.labelName,
				labelColor: clientLabel.labelColor
			}))
		}

		const handleDelete = () => {
			dispatch(modalActions.showModal({
				modalType: ModalTypes.DELETE_CLIENT_LABEL_MODAL,
				data: {
					labelId: clientLabel.labelId,
					labelName: clientLabel.labelName,
					labelColor: clientLabel.labelColor
				}
			}))
		}

		return (
			<>

				<Tooltip title="Edit label" placement="top">
					<Button
						size="large"
						onClick={handleEdit}
					>
						<SvgIcon icon={faPenToSquare} />
					</Button>

				</Tooltip>
				<Tooltip title="Delete label" placement="top">
					<Button
						color="error"
						size="large"
						onClick={handleDelete}
					>
						<SvgIcon icon={faTrashCan} />
					</Button>
				</Tooltip>
			</>
		)
	})